import React, { useState } from 'react';
import { useClassName } from 'common/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import useCustomStyle from '../../hooks';
import useSlider from 'public/screens/Home/Components/useSlider';
import './carousel-type-f.less';
import CarouselAsset from './CarouselAsset';
import CarouselCard from './CarouselCard';
import CarouselCounter from '../CarouselCounter';
import CarouselArrows from '../CarouselArrows';

function getBreakpoints(component) {
  const slidesPerView = component?.fields?.settings?.find(
    (setting) => setting.fields.key === '--slides-per-view'
  );
  if (!slidesPerView) return {};
  return {
    0: {
      slidesPerView: slidesPerView.fields.mobileValue,
    },
    768: {
      slidesPerView: slidesPerView.fields.tabletValue,
    },
    1128: {
      slidesPerView: slidesPerView.fields.desktopValue,
    },
  };
}

export default function CarouselTypeF({ component, refs, handleTrack }) {
  const [paused, setPaused] = useState(false);
  const classNames = useClassName('CLPCarouselTypeF');
  const [, styles] = useCustomStyle(component.fields.settings);
  const [props, methods, state] = useSlider();
  const slides = component.fields.slides;
  const sliderStyles = {
    ...(styles['--margin'] && { margin: styles['--margin'] }),
    ...(styles['--margin-top'] && { marginTop: styles['--margin-top'] }),
    ...(styles['--margin-bottom'] && {
      marginBottom: styles['--margin-bottom'],
    }),
  };

  return (
    <div className={classNames('container')} style={sliderStyles}>
      <Swiper
        height={styles['--height'] || 500}
        centeredSlides={true}
        spaceBetween={parseInt(styles['--space-between']) || 20}
        speed={100}
        loop={true}
        breakpoints={getBreakpoints(component)}
        {...props}>
        {slides.map((slide, index) => (
          <SwiperSlide
            key={index}
            className={classNames('slide-container')}
            style={Object.fromEntries(
              Object.entries(styles)
                .filter(([key]) => key.startsWith('--slide'))
                .map(([key, value]) => [key.replace('--slide-', ''), value])
            )}>
            {({ isActive }) => {
              return slide.sys.contentType.sys.id === 'lpAsset' ? (
                <CarouselAsset
                  slide={slide}
                  setPaused={setPaused}
                  settings={component.fields.settings}
                  isActive={isActive}
                />
              ) : (
                <CarouselCard
                  slide={slide}
                  setPaused={setPaused}
                  refs={refs}
                  isActive={isActive}
                />
              );
            }}
          </SwiperSlide>
        ))}
      </Swiper>
      {slides.length > 1 && (
        <>
          <div className={classNames('arrows-container')}>
            <CarouselArrows
              next={methods.slideNext}
              prev={methods.slidePrev}
              type={component.fields.type}
              theme={component.fields.theme}
              settings={component.fields.settings}
              trackDirection={(direction) =>
                handleTrack && handleTrack(direction)
              }
            />
          </div>
          <div className={classNames('counter-container')}>
            <CarouselCounter
              current={state.activeIndex + 1}
              total={slides.length}
              next={methods.slideNext}
              goTo={methods.slideTo}
              paused={paused}
              autoplayDuration={component.fields.autoplayDuration}
              type={component.fields.type}
              theme={component.fields.theme}
            />
          </div>
        </>
      )}
    </div>
  );
}
